(function () {
  var days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var months = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];

  function computeDeliveryText() {
    var now = new Date();
    var delivery = new Date(now);
    if (now.getHours() >= 23) {
      delivery.setDate(delivery.getDate() + 2);
    } else {
      delivery.setDate(delivery.getDate() + 1);
    }
    if (delivery.getDay() === 0) {
      delivery.setDate(delivery.getDate() + 1);
    }
    return days[delivery.getDay()] + ' ' + delivery.getDate() + ' ' + months[delivery.getMonth()];
  }

  function update() {
    var nodes = document.querySelectorAll('.js-dynamic-shipping-text');
    if (!nodes.length) return;
    var text = computeDeliveryText();
    nodes.forEach(function (el) {
      el.innerHTML = 'Verwachte levering: <strong>' + text + '</strong>';
    });
  }

  window.updateDynamicShippingMessage = update;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  document.addEventListener('cart:updated', update);
  document.addEventListener('cart:refresh', update);
})();
